var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.$session.get("ProcesoElectoral")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }